// document.addEventListener("DOMContentLoaded", () => {
//     // Promo Code Toggle
//     const promoBlock = document.querySelector(".promo-code-block");

//     if (promoBlock) {
//         const toggleBtn = promoBlock.querySelector(".toggle-btn");
//         const promoLabel = promoBlock.querySelector(".promo-label");

//         toggleBtn.addEventListener("click", function () {
//             const isOpen = promoBlock.classList.toggle("is-open");
//             this.setAttribute("aria-expanded", isOpen);
//             promoLabel.textContent = isOpen ? "Promo code" : "Have a promo code?";
//         });
//     }

//     // Cart Table
//     const tableBody = document.querySelector(".products-table .table-body");

//     if (tableBody) {
//         function parsePrice(str) {
//             return parseFloat(str.replace(/[^0-9.]/g, "")) || 0;
//         }

//         function formatPrice(num) {
//             return "$" + num.toFixed(2);
//         }

//         function updateSummary() {
//             let subtotal = 0;

//             tableBody.querySelectorAll(".product-row").forEach((row) => {
//                 subtotal += parsePrice(
//                     row.querySelector(".total-price").textContent
//                 );
//             });

//             const discountEl = document.querySelector(".pricing-block .green-text");
//             const discount = discountEl ? parsePrice(discountEl.textContent) : 0;

//             document
//                 .querySelectorAll(
//                     ".pricing-block .value:not(.green-text):not(.total-price)"
//                 )
//                 .forEach((el) => {
//                     el.textContent = formatPrice(subtotal);
//                 });

//             const totalPriceEl = document.querySelector(
//                 ".pricing-block .total-price.value"
//             );

//             if (totalPriceEl) {
//                 totalPriceEl.textContent = formatPrice(
//                     Math.max(0, subtotal - discount)
//                 );
//             }
//         }

//         // tableBody.addEventListener("click", (e) => {
//         //     const btn = e.target.closest(".qty-btn");

//         //     if (!btn) return;

//         //     const row = btn.closest(".product-row");
//         //     const qtyEl = row.querySelector(".qty-value");
//         //     const unitPrice = parsePrice(
//         //         row.querySelector(".sale-price").textContent
//         //     );

//         //     let qty = parseInt(qtyEl.textContent, 10);
//         //     const isIncrease = btn.getAttribute("title") === "Increase";

//         //     const decreaseBtn = row.querySelector(
//         //         '.qty-btn[title="Decrease"]'
//         //     );

//         //     if (!isIncrease && qty <= 1) return;

//         //     qty = isIncrease ? qty + 1 : qty - 1;

//         //     qtyEl.textContent = qty;
//         //     row.querySelector(".total-price").textContent = formatPrice(
//         //         unitPrice * qty
//         //     );

//         //     decreaseBtn.disabled = qty <= 1;
//         //     decreaseBtn.style.opacity = qty <= 1 ? "0.4" : "1";

//         //     updateSummary();
//         // });

//         tableBody.addEventListener("click", (e) => {
//             const removeBtn = e.target.closest(".remove-btn");

//             if (!removeBtn) return;

//             removeBtn.closest(".product-row").remove();
//             updateSummary();
//         });
//     }

//     // Swiper
//     new Swiper(".frequently-bought-swiper", {
//         slidesPerView: 1.75,
//         spaceBetween: 10,
//         navigation: {
//             nextEl: ".frequently-buy-products-block .swiper-button-next",
//             prevEl: ".frequently-buy-products-block .swiper-button-prev",
//         },
//         breakpoints: {
//             575: {
//                 slidesPerView: 2.5,
//             },
//             768: {
//                 slidesPerView: "auto",
//             },
//         },
//     });
// });

// document.addEventListener("click", (e) => {

//     const plus = e.target.closest(".qty-btn.plus");
//     const minus = e.target.closest(".qty-btn.minus");

//     if (!plus && !minus) return;

//     const row = e.target.closest(".product-row");

//     const input = row.querySelector(
//         'quantity-selector-component input'
//     );

//     let qty = Number(input.value);

//     qty = plus ? qty + 1 : Math.max(0, qty - 1);

//     input.value = qty;

//     input.dispatchEvent(
//         new Event("change",{bubbles:true})
//     );

// });
/**
 * custom-cart-page.js
 *
 * Powers the custom cart page's quantity steppers and remove buttons.
 *
 * Strategy: every change posts to /cart/change.js and asks Shopify to also
 * re-render this section's HTML (the `sections` param on the request). We
 * then swap the pieces of the DOM that can change — the item rows, the two
 * order-summary blocks, the cart-count badge, and the checkout button's
 * disabled state — with the freshly rendered markup. This keeps all the
 * money formatting, discount %, and empty-cart logic server-side (in
 * Liquid) instead of re-implementing it in JS.
 */
(function () {
  const SELECTORS = {
    section: '[data-cart-section]',
    items: '[data-cart-items]',
    row: '.product-row',
    qtyValue: '[data-qty-value]',
    rowError: '[data-row-error]',
    summary: '[data-cart-summary]',
    count: '[data-cart-count]',
    checkout: '[data-checkout-btn]',
    emptyState: '[data-cart-empty-state]',
    loader: '.custom-loader',
    promoBlock: '[data-promo-block]',
    promoToggle: '[data-promo-toggle]',
    promoInput: '[data-promo-input]',
    promoApply: '[data-promo-apply]',
    promoRemove: '[data-promo-remove]',
    promoError: '[data-promo-error]',
  };

  function init() {
    const section = document.querySelector(SELECTORS.section);
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const changeUrl = section.dataset.cartChangeUrl;
    const cartUrl = section.dataset.cartUrl;
    const updateUrl = section.dataset.cartUpdateUrl;

    // Track in-flight line updates so a fast double-click can't race itself.
    const pendingLines = new Set();

    section.addEventListener('click', onClick);

    // --- Keep this page in sync when the cart changes elsewhere -----------
    //
    // Adding to cart from a product page, quick-add, upsell block, etc.
    // doesn't happen inside this section, so the click handler above never
    // fires for it. This theme dispatches CartUpdateEvent / CartAddEvent
    // (both under ThemeEvents.cartUpdate = 'cart:update') on `document`
    // whenever the cart changes anywhere — see assets/events.js, which also
    // exposes it as window.ThemeEvents so a plain script can use it safely.
    const CART_UPDATE_EVENT = window.ThemeEvents?.cartUpdate || 'cart:update';
    const CART_ERROR_EVENT = window.ThemeEvents?.cartError || 'cart:error';

    document.addEventListener(CART_UPDATE_EVENT, onExternalCartUpdate);
    document.addEventListener(CART_ERROR_EVENT, refreshFromServer);

    // Also catch the case where the browser restores this page from
    // back/forward cache (bfcache) after the user added something on
    // another page and hit "back" — pageshow fires, a normal load doesn't.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refreshFromServer();
    });

    // Manual escape hatch: call this directly after any cart change if
    // nothing above catches it —
    //   window.CustomCartPage && window.CustomCartPage.refresh();
    window.CustomCartPage = { refresh: refreshFromServer };

    /**
     * Handles CartUpdateEvent / CartAddEvent dispatched elsewhere in the
     * theme. If the event already carries this section's rendered HTML
     * (event.detail.data.sections[sectionId]) we use it directly — no
     * extra request needed. Otherwise we fall back to fetching it.
     */
    function onExternalCartUpdate(event) {
      // Skip events this script dispatched itself — updateLine() already
      // rendered the result directly, so handling it again here would
      // trigger a redundant (and race-prone) second render.
      if (event.detail && event.detail.data && event.detail.data.source === 'custom-cart-page') {
        return;
      }

      const sectionsFromEvent = event.detail && event.detail.data && event.detail.data.sections;
      const html = sectionsFromEvent && sectionsFromEvent[sectionId];

      if (html) {
        renderSection(html);
      } else {
        refreshFromServer();
      }
    }

    async function refreshFromServer() {
      if (!cartUrl) return;
      try {
        const response = await fetch(`${cartUrl}?sections=${sectionId}`, {
          headers: { Accept: 'application/json' },
        });
        const data = await response.json();
        const sectionHtml = data && data[sectionId];
        if (sectionHtml) renderSection(sectionHtml);
      } catch (error) {
        console.error('[custom-cart-page] failed to refresh cart', error);
      }
    }

    section.addEventListener('keydown', onKeydown);

    function onKeydown(event) {
      if (event.key !== 'Enter') return;
      const input = event.target.closest(SELECTORS.promoInput);
      if (!input) return;
      event.preventDefault();
      const block = input.closest(SELECTORS.promoBlock);
      const code = input.value.trim();
      if (code) applyDiscount(code, block);
    }

    function onClick(event) {
      const promoToggle = event.target.closest(SELECTORS.promoToggle);
      if (promoToggle) {
        const block = promoToggle.closest(SELECTORS.promoBlock);
        if (block) {
          const isOpen = block.classList.toggle('is-open');
          promoToggle.setAttribute('aria-expanded', String(isOpen));
        }
        return;
      }

      const promoApplyBtn = event.target.closest(SELECTORS.promoApply);
      if (promoApplyBtn) {
        const block = promoApplyBtn.closest(SELECTORS.promoBlock);
        const input = block?.querySelector(SELECTORS.promoInput);
        const code = input?.value.trim();
        if (code) applyDiscount(code, block);
        return;
      }

      const promoRemoveBtn = event.target.closest(SELECTORS.promoRemove);
      if (promoRemoveBtn) {
        const code = promoRemoveBtn.dataset.promoRemove;
        const block = promoRemoveBtn.closest(SELECTORS.promoBlock);
        if (code) removeDiscount(code, block);
        return;
      }

      const minusBtn = event.target.closest('.qty-btn.minus');
      const plusBtn = event.target.closest('.qty-btn.plus');
      const removeBtn = event.target.closest('.remove-btn');

      if (!minusBtn && !plusBtn && !removeBtn) return;

      const button = minusBtn || plusBtn || removeBtn;
      const row = button.closest(SELECTORS.row);
      if (!row) return;

      const line = Number(button.dataset.line || row.dataset.line);
      if (!line || pendingLines.has(line)) return;

      if (removeBtn) {
        updateLine(line, 0, row);
        return;
      }

      const qtyEl = row.querySelector(SELECTORS.qtyValue);
      const currentQty = parseInt(qtyEl?.textContent.trim(), 10) || 0;
      const nextQty = plusBtn ? currentQty + 1 : Math.max(0, currentQty - 1);

      updateLine(line, nextQty, row);
    }

    async function updateLine(line, quantity, row) {
      pendingLines.add(line);
      row.classList.add('row-updating');
      showLoader();
      clearRowError(row);

      try {
        const response = await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            line: line,
            quantity: quantity,
            sections: sectionId,
          }),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          showRowError(row, data.description || data.message || 'This item could not be updated.');
          return;
        }

        const sectionHtml = data.sections && data.sections[sectionId];
        if (sectionHtml) {
          renderSection(sectionHtml, { removedLine: quantity === 0 ? line : null, row });
        }

        // Tell the rest of the theme (cart icon, upsells, etc.) that the
        // cart changed — otherwise only this section knows.
        dispatchCartUpdate(data);
      } catch (error) {
        console.error('[custom-cart-page] failed to update cart line', error);
        showRowError(row, 'Something went wrong. Please try again.');
      } finally {
        pendingLines.delete(line);
        hideLoader();
      }
    }

    /**
     * Reads every currently-applied discount code from the DOM (both the
     * mobile and desktop promo blocks render the same server state, so any
     * one of them is authoritative — using a Set just de-dupes across both).
     */
    function getCurrentDiscountCodes() {
      const codes = new Set();
      section.querySelectorAll('[data-promo-code]').forEach((el) => {
        const code = el.dataset.promoCode;
        if (code) codes.add(code);
      });
      return codes;
    }

    function applyDiscount(code, block) {
      const codes = getCurrentDiscountCodes();
      codes.add(code);
      updateDiscounts(Array.from(codes), block);
    }

    function removeDiscount(code, block) {
      const codes = getCurrentDiscountCodes();
      codes.delete(code);
      updateDiscounts(Array.from(codes), block);
    }

    /**
     * Applies (or clears) the cart's discount codes via /cart/update.js,
     * which accepts a `discount` field — a comma-separated list of codes —
     * and returns the full updated cart, same shape as /cart/change.js.
     *
     * Note: Shopify returns 200 OK even for an unknown/inapplicable code —
     * there's no dedicated error for "bad discount code." The re-rendered
     * section (from Liquid, via cart.discount_codes) is what actually shows
     * whether each code applied — see custom-cart-promo-code.liquid's
     * "(not applicable to items in cart)" note.
     */
    async function updateDiscounts(codesArray, block) {
      if (!updateUrl) return;

      showLoader();
      clearPromoError(block);

      try {
        const response = await fetch(updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            discount: codesArray.join(','),
            sections: sectionId,
          }),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          showPromoError(block, data.description || data.message || 'Could not update promo code.');
          return;
        }

        const sectionHtml = data.sections && data.sections[sectionId];
        if (sectionHtml) renderSection(sectionHtml);

        dispatchCartUpdate(data);
      } catch (error) {
        console.error('[custom-cart-page] failed to update discount codes', error);
        showPromoError(block, 'Something went wrong. Please try again.');
      } finally {
        hideLoader();
      }
    }

    function showPromoError(block, message) {
      const errorEl = block?.querySelector(SELECTORS.promoError);
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearPromoError(block) {
      const errorEl = block?.querySelector(SELECTORS.promoError);
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    /**
     * Toggles the .custom-loader element that sits inside the items table.
     * On a successful update the whole [data-cart-items] container
     * (loader included) gets replaced with a fresh, inactive copy anyway —
     * this mainly matters for the error path, where nothing gets swapped.
     */
    function showLoader() {
      const loader = section.querySelector(SELECTORS.loader);
      if (loader) loader.classList.add('active');
    }

    function hideLoader() {
      const loader = section.querySelector(SELECTORS.loader);
      if (loader) loader.classList.remove('active');
    }

    /**
     * Broadcasts a cart change to the rest of the theme using the same
     * event cart-icon.js (and anything else) already listens for.
     * @param {object} cart - The cart object returned by /cart/change.js or /cart.js
     */
    function dispatchCartUpdate(cart) {
      const detailData = {
        itemCount: cart.item_count,
        source: 'custom-cart-page',
        sections: cart.sections,
      };

      if (window.CartUpdateEvent) {
        document.dispatchEvent(new window.CartUpdateEvent(cart, sectionId, detailData));
      } else {
        const eventName = (window.ThemeEvents && window.ThemeEvents.cartUpdate) || 'cart:update';
        document.dispatchEvent(
          new CustomEvent(eventName, {
            bubbles: true,
            detail: { resource: cart, sourceId: sectionId, data: detailData },
          })
        );
      }
    }

    function renderSection(html, { removedLine, row } = {}) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newSection = parsed.querySelector(SELECTORS.section);
      if (!newSection) return;

      // The cart just transitioned to/from empty. Neither direction can be
      // handled by the usual partial swaps: going empty removes the whole
      // summary/checkout/upsell markup (not just the product list), and
      // going non-empty means .products-table doesn't exist yet for
      // swapRows to target. A reload is simpler and safer for this one
      // relatively rare transition; every other update still does the
      // fast partial DOM swap below.
      const newEmptyState = newSection.querySelector(SELECTORS.emptyState);
      const currentEmptyState = section.querySelector(SELECTORS.emptyState);
      if (!!newEmptyState !== !!currentEmptyState) {
        window.location.reload();
        return;
      }

      swapRows(newSection, removedLine, row);
      swapAll(newSection, SELECTORS.summary);
      swapAll(newSection, SELECTORS.promoBlock);
      swapText(newSection, SELECTORS.count);
      syncCheckoutButtons(newSection);
    }

    function swapRows(newSection, removedLine, row) {
      const newItems = newSection.querySelector(SELECTORS.items);
      const oldItems = section.querySelector(SELECTORS.items);
      if (!newItems || !oldItems) return;

      if (removedLine && row) {
        // Animate the row out, then drop in the freshly numbered rows so
        // every remaining button's data-line stays correct.
        row.classList.add('removing');
        row.addEventListener(
          'transitionend',
          () => oldItems.replaceWith(newItems),
          { once: true }
        );
        // Fallback in case there's no CSS transition defined for .removing.
        window.setTimeout(() => {
          if (oldItems.isConnected) oldItems.replaceWith(newItems);
        }, 300);
      } else {
        oldItems.replaceWith(newItems);
      }
    }

    function swapAll(newSection, selector) {
      const newEls = newSection.querySelectorAll(selector);
      const oldEls = section.querySelectorAll(selector);
      newEls.forEach((el, i) => {
        if (oldEls[i]) oldEls[i].replaceWith(el);
      });
    }

    function swapText(newSection, selector) {
      const newEls = newSection.querySelectorAll(selector);
      const oldEls = section.querySelectorAll(selector);
      newEls.forEach((el, i) => {
        if (oldEls[i]) oldEls[i].textContent = el.textContent;
      });
    }

    function syncCheckoutButtons(newSection) {
      const newBtns = newSection.querySelectorAll(SELECTORS.checkout);
      const oldBtns = section.querySelectorAll(SELECTORS.checkout);
      newBtns.forEach((btn, i) => {
        if (oldBtns[i]) oldBtns[i].toggleAttribute('disabled', btn.hasAttribute('disabled'));
      });
    }

    function showRowError(row, message) {
      row.classList.remove('row-updating');
      const errorEl = row.querySelector(SELECTORS.rowError);
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearRowError(row) {
      const errorEl = row.querySelector(SELECTORS.rowError);
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


